import { MediaWithMaskBg } from '@/app/components/shared/MediaWithMaskBg';
import { cn } from '@/app/utils';

interface MultiImageGridProps {
  images: string[];
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

const IMAGE_CLASS_MAP: Record<number, string | string[]> = {
  1: 'w-full h-full',
  2: 'h-full w-[calc(50%-1px)]',
  3: ['w-full h-[calc(50%-1px)]', 'w-[calc(50%-1px)] h-[calc(50%-1px)]', 'w-[calc(50%-1px)] h-[calc(50%-1px)]'],
};

export const MultiImageGrid: React.FC<MultiImageGridProps> = ({ images, className, onClick, children }) => {
  return (
    <div className={cn('flex h-full w-full flex-wrap gap-0.5 overflow-hidden rounded-2', className)} onClick={onClick}>
      {images.map((image, idx) => {
        const classInfo = IMAGE_CLASS_MAP[images.length || 1];
        return (
          <MediaWithMaskBg
            key={image}
            className={cn(Array.isArray(classInfo) ? classInfo[idx] : classInfo)}
            src={image}
            alt="original_image"
          />
        );
      })}
      {children}
    </div>
  );
};
